"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearMonthForm = void 0;
var react_1 = __importDefault(require("react"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var YearMonthForm = /** @class */ (function (_super) {
    __extends(YearMonthForm, _super);
    function YearMonthForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeDate = function (e, fromMonth, toMonth) {
            e.preventDefault();
            var triggeredBy = e.currentTarget.name;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var childs = e.currentTarget.parentElement;
            var data = {};
            var child = childs.firstChild;
            while (child !== null) {
                if (child.name && child.value) {
                    data[child.name] = child.value;
                }
                child = child.nextSibling;
            }
            if (triggeredBy === "year") {
                var tempDate = new Date(data.year, data.month);
                var startMonth = tempDate.getFullYear() === fromMonth.getFullYear() ? fromMonth.getMonth() : 0;
                var endMonth = tempDate.getFullYear() === toMonth.getFullYear() ? toMonth.getMonth() : 12;
                if (data.month < startMonth) {
                    data.month = startMonth;
                }
                else if (data.month > endMonth) {
                    data.month = endMonth;
                }
            }
            _this.props.onChange(new Date(data.year, data.month));
        };
        return _this;
    }
    YearMonthForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, fromMonth = _a.fromMonth, toMonth = _a.toMonth, date = _a.date;
        var months = LocaleProvider_1.default.locs.date_picker.strings.months;
        var startMonth = date.getFullYear() === fromMonth.getFullYear() ? fromMonth.getMonth() : 0;
        var endMonth = date.getFullYear() === toMonth.getFullYear() ? toMonth.getMonth() : 12;
        var startYear = fromMonth.getFullYear();
        var stopYear = toMonth.getFullYear();
        var selectedYear = date.getFullYear();
        var years = [];
        if (selectedYear < startYear) {
            years.push(selectedYear);
        }
        for (var i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
            years.push(i);
        }
        // We want two conditions, in first case is to push year in front of all
        // in the second case as last item.
        if (selectedYear > stopYear) {
            years.push(selectedYear);
        }
        var handleChange = function (e) { return _this.changeDate(e, fromMonth, toMonth); };
        return (react_1.default.createElement("div", { className: "DayPicker-Caption" },
            react_1.default.createElement("select", { name: "month", onChange: handleChange, value: date.getMonth() }, months.map(function (month, i) {
                if (i >= startMonth && i <= endMonth) {
                    return (react_1.default.createElement("option", { key: month, value: i }, month));
                }
            })),
            react_1.default.createElement("select", { name: "year", onChange: handleChange, value: date.getFullYear() }, years.map(function (year) { return (react_1.default.createElement("option", { key: year, value: year }, year)); }))));
    };
    return YearMonthForm;
}(react_1.default.PureComponent));
exports.YearMonthForm = YearMonthForm;
//# sourceMappingURL=YearMonthForm.js.map